export default __webpack_public_path__ + "static/media/sweets-31.97c2b5a5.png";